<template>
    <span>
        <i class="fa fa-trash pointer text-danger ml-2" @click="$refs.deleteMemberModal.open()"></i>

        <!-- Delete member modal -->
        <sweet-modal :title="$t('UI_INSTANCE_MEMBER_GROUP_MEMBER_DELETE_MODAL_TITLE')" ref="deleteMemberModal" class="text-left">
            <p v-html="$t('UI_INSTANCE_MEMBER_GROUP_MEMBER_DELETE', {member: member.name, group: group.name})"></p>
            <div slot="button">
                <button class="btn btn-danger" @click="deleteMember">
                    {{ $t("UI_MODAL_BUTTON_DELETE") }}
                </button>
                <button class="btn btn-secondary ml-1" @click="$refs.deleteMemberModal.close()">
                    {{ $t("UI_MODAL_BUTTON_CLOSE") }}
                </button>
            </div>
        </sweet-modal>
    </span>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue';
import { RepositoryFactory } from '../../../../../repositories/RepositoryFactory';

const ChannelMemberRepository = RepositoryFactory.get('channelMembers');

export default {
  name: 'MemberDelete',
  props: ['member', 'group'],
  components: { SweetModal },
  methods: {
    deleteMember() {
      ChannelMemberRepository.deleteMemberFromGroup(this.group.id, this.member.id).then(() => {
        this.$snotify.info(this.$t('UI_INSTANCE_MEMBER_GROUP_MEMBER_DELETED', { member: this.member.name, group: this.group.name }));
        ChannelMemberRepository.refetchMemberList();
        this.$refs.deleteMemberModal.close();
      });
    },
  },
};
</script>

<style scoped>

</style>
